import styled from 'styled-components';

export const Content = styled.div`
  margin-top: 0px;
  min-width: 1119px;
  width:99.7%;
  min-height: 768px;
  height: 100%;
  padding-left: 0px;
  padding-top: 0px;
  background-color:#F5F5F5;
`;

export const LinkButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 10px 16px;

  svg {
      margin: 0 8px;
  }

  span {
    font-weight: bold;
    color: #EC6E0C;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const SideMenu = styled.div`
  position:absolute;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 246px;
  min-height: 768px;
  height: 100%;
  overflow: hidden;
  background-color:#3C393C;
  color: white;
`;

export const ContentBody = styled.div`
  width:auto;
  height: 100%;
  padding-left: 286px;
  padding-top: 24px;
  background-color:#F5F5F5;
`;

export const Main = styled.div`
  margin:0;
  padding: 0;
`;

export const Logo = styled.div`
  height: 40px;
  margin-top: 24px;
  margin-left: 40px;
`;

export const MenuItem = styled.li`
  text-align: left;
  line-height:22px;
  letter-spacing: 0px;
  color: ${(props) => props.theme.white};
  opacity: 1;
  padding:10px;
  width:215px;
  vertical-align: middle;
`;

export const MenuSubItem = styled.li`
  text-align: left;
  line-height:22px;
  letter-spacing: 0px;
  color: ${(props) => props.theme.white};
  opacity: 1;
  padding:5px;
  width:215px;
  vertical-align: middle;
  margin-left:15px;

  a {
    font-weight: lighter !important;
  }

  a:hover{
    color: ${(props) => props.theme.orange} !important;
    text-decoration: underline !important;
  }
  
`;

export const BreadWay = styled.div`
  text-align: left;
  letter-spacing: 0px;
  color: #5b5b4f;
`;

export const PageTitle = styled.div`
  text-align: left;
  font-weight:bold;
  letter-spacing: 0px;
  color: ${(props) => props.theme.black};
`;
